module.exports = __webpack_public_path__ + "static/media/bridgerton_cover.876401d7.jpg";